import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from './stores/auth';
const routes = [
    { path: '/setup', component: () => import('./views/SetupView.vue'), meta: { public: true } },
    { path: '/login', component: () => import('./views/LoginView.vue'), meta: { public: true } },
    { path: '/', component: () => import('./views/DashboardView.vue') },
    { path: '/menu', component: () => import('./views/MenuView.vue') },
    { path: '/recipes', component: () => import('./views/RecipesView.vue') },
    { path: '/shopping', component: () => import('./views/ShoppingView.vue') },
    { path: '/pantry', component: () => import('./views/PantryView.vue') },
    { path: '/leftovers', component: () => import('./views/LeftoversView.vue') },
    { path: '/notifications', component: () => import('./views/NotificationsView.vue') },
    { path: '/downloads', component: () => import('./views/DownloadsView.vue') },
    { path: '/admin', component: () => import('./views/AdminView.vue'), meta: { requiresAdmin: true } }
];
const router = createRouter({ history: createWebHistory(), routes });
router.beforeEach(async (to) => {
    const auth = useAuthStore();
    const status = await auth.loadSetupStatus();
    if (!status.completed && to.path !== '/setup')
        return '/setup';
    if (status.completed && to.path === '/setup')
        return auth.isAuthenticated ? '/' : '/login';
    if (!to.meta.public && !auth.isAuthenticated)
        return '/login';
    if (!to.meta.public && auth.isAuthenticated) {
        try {
            await auth.refreshMe();
        }
        catch {
            auth.logout();
            return false;
        }
    }
    if (to.meta.requiresAdmin && !auth.isAdmin)
        return '/';
});
export default router;
